"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ProductIconContainer = _interopRequireDefault(require("../common/ProductIcon/ProductIconContainer"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
var _CryptoNavItemsContainer = _interopRequireDefault(require("../WalletNavItems/CryptoNavItemsContainer"));
var _FiatNavItemsContainer = _interopRequireDefault(require("../WalletNavItems/FiatNavItemsContainer"));
var _FiatDeposit = require("../Retail/RetailSidePanes/FiatDeposit");
var _APIconButton = _interopRequireDefault(require("../common/APIconButton/APIconButton"));
var _MarginTransferAssetsModal = _interopRequireDefault(require("../MarginTransferAssetModal/MarginTransferAssetsModal"));
require("./WalletDetails.css");
var _numberFormatter = require("../../helpers/numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('wallet-details');
var cryptoNavItemsClasses = (0, _cssClassesHelper.getBEMClasses)('wallet-nav-item');
var WalletDetailsComponent = function WalletDetailsComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  var verificationLevelConfig = props.verificationLevelConfig,
    openWhitelistSidepane = props.openWhitelistSidepane,
    isMarginActive = props.isMarginActive,
    isFuturesActive = props.isFuturesActive;
  var _props$positionDetail = props.positionDetails,
    iconFileName = _props$positionDetail.iconFileName,
    Product = _props$positionDetail.Product,
    ProductFullName = _props$positionDetail.ProductFullName,
    AvailableBalance = _props$positionDetail.AvailableBalance,
    Hold = _props$positionDetail.Hold,
    PendingDeposits = _props$positionDetail.PendingDeposits,
    Amount = _props$positionDetail.Amount,
    ProductType = _props$positionDetail.ProductType,
    ProductId = _props$positionDetail.ProductId,
    rawAmount = _props$positionDetail.rawAmount,
    DepositEnabled = _props$positionDetail.DepositEnabled,
    WithdrawEnabled = _props$positionDetail.WithdrawEnabled;
  var baseCurrency = props.baseCurrency;
  var isCrypto = ProductType === 'CryptoCurrency';
  var renderPositionDetails = function renderPositionDetails(label, value) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: baseClasses('detail')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: baseClasses('label')
    }, t(label)), /*#__PURE__*/_react["default"].createElement("div", {
      className: baseClasses('value')
    }, value));
  };
  var baseCurrencyTitle;
  if (baseCurrency) {
    var convertedValue = rawAmount * baseCurrency.value;
    var formattedValue = (0, _numberFormatter.formatNumberToLocale)(convertedValue, baseCurrency.DecimalPlaces);
    baseCurrencyTitle = "(".concat(baseCurrency.Product, " ").concat(formattedValue, ")");
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, props.fetching ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    isInline: true,
    customClass: baseClasses
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('product-actions-row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('product-label')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('product-icon')
  }, /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
    iconFileName: iconFileName,
    size: 48
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('product-symbol-name')
  }, "".concat(Product, " ").concat(ProductFullName), ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('product-conversion')
  }, baseCurrencyTitle))), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('wallet-nav-items')
  }, isCrypto ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, verificationLevelConfig.RequireWhitelistedAddress && /*#__PURE__*/_react["default"].createElement(_APIconButton["default"], {
    action: function action() {
      return openWhitelistSidepane(props.positionDetails);
    },
    iconName: 'tasks',
    label: t('Add Address'),
    customClass: cryptoNavItemsClasses()
  }), /*#__PURE__*/_react["default"].createElement(_CryptoNavItemsContainer["default"], {
    product: {
      iconFileName: iconFileName,
      ProductFullName: ProductFullName,
      ProductSymbol: Product,
      ProductId: ProductId,
      DepositEnabled: DepositEnabled,
      WithdrawEnabled: WithdrawEnabled
    },
    margin: isMarginActive,
    futures: isFuturesActive
  })) : /*#__PURE__*/_react["default"].createElement(_FiatNavItemsContainer["default"], {
    product: {
      iconFileName: iconFileName,
      ProductFullName: ProductFullName,
      ProductSymbol: Product,
      ProductId: ProductId,
      DepositEnabled: DepositEnabled,
      WithdrawEnabled: WithdrawEnabled
    },
    margin: isMarginActive,
    futures: isFuturesActive
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('position-row')
  }, renderPositionDetails('Available Balance', AvailableBalance), renderPositionDetails('Hold', Hold), renderPositionDetails('Pending Deposits', PendingDeposits), renderPositionDetails('Total Balance', Amount)), /*#__PURE__*/_react["default"].createElement(_FiatDeposit.DepositReferenceIdModalContainer, null), /*#__PURE__*/_react["default"].createElement(_MarginTransferAssetsModal["default"], null)));
};
WalletDetailsComponent.propTypes = {
  positionDetails: _propTypes["default"].object,
  fetching: _propTypes["default"].bool.isRequired,
  isMarginActive: _propTypes["default"].bool,
  isFuturesActive: _propTypes["default"].bool
};
var _default = exports["default"] = WalletDetailsComponent;